(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('TravelExpensesUploadStatementController', TravelExpensesUploadStatementController);

        TravelExpensesUploadStatementController.$inject = ['API_BASE', 'TravelExpenseService', 'ExpensesService', 'AccountService', '$timeout', 'FileUploader', 'toastr', 'AdmService'];
    function TravelExpensesUploadStatementController(API_BASE, TravelExpenseService, ExpensesService, AccountService, $timeout, FileUploader, toastr, AdmService) {
        
        var vm                  = this;
        vm.activate             = activate;
        vm.uploadFile           = uploadFile;
        vm.getBankAccounts      = getBankAccounts;
        vm.bankAccountSelected  = '';
        vm.staffSelected        = '';
        vm.tokenHeader          = 'Bearer ' + localStorage.getItem('id_token');
        vm.statements           = [];
        vm.checkedAll           = false;
        vm.checkAll             = checkAll;
        vm.statements           = [];
        vm.save                 = save;
        vm.getStaff             = getStaff;
        vm.file                 = null;
        vm.uploadFile           = uploadFile;

        function activate () {            
            vm.getBankAccounts();            
            vm.getStaff();
        }

        function getBankAccounts () {
            AccountService.getBankAccounts().then(function(response){
                vm.bankAccountList = response.data;
            });
        }

        function getStaff () {
            AdmService.getAdmUsersStaff().then(function(response){
                vm.staff = response.data;
            });
        }

        function checkAll()
        {
            if(vm.checkedAll === true){
                angular.forEach(vm.statements, function(value, key) {
                    value.checked = true;
                });
            }
            else{
                angular.forEach(vm.statements, function(value, key) {
                    value.checked = false;
                });
            }
        }

        function save()
        {
            let query = {};
            query['statements'] = vm.statements;
            query['adm_user_id'] = vm.staffSelected;
            query['account_id'] = vm.bankAccountSelected;
            TravelExpenseService.saveStatements(query).then(function(response){
                toastr.success(response.data.message);
                vm.statements = [];
                vm.flag = false;
                vm.bankAccountSelected = '';
                vm.staffSelected = '';
                vm.file = '';
                angular.forEach(
                    angular.element("input[type='file']"),
                    function(inputElem) {
                        angular.element(inputElem).val(null);
                    });
            }).catch(function(err) {
            });
        }

        function uploadFile () {
            var file =  vm.file;
            console.log('file is ' );
            console.dir(vm.file);
            var data = { account_id : vm.bankAccountSelected, adm_user_id: vm.staffSelected };
            TravelExpenseService.uploadFile(file, data).then(function (response) {
                vm.statements = response.data;
            });
         };

        vm.activate();
    }

})();